__turbopack_context__.v({
  "bannerWrapper": "lV2gSq_bannerWrapper",
  "blurb": "lV2gSq_blurb",
  "customerNumber": "lV2gSq_customerNumber",
  "link": "lV2gSq_link",
  "profileImage": "lV2gSq_profileImage",
  "profileText": "lV2gSq_profileText",
});
